import {Component, Input} from "@angular/core";
import {CalendarDaySlot, CalendarTime} from "../../../../../../../../entities/CalendarDaySlot";
import {CalendarSlot} from "../../../../../../../../entities/CalendarSlot";

@Component({
    selector: 'leasing-empty-slot',
    styleUrls: ['./emptySlot.scss'],
    templateUrl: './emptySlot.html'
})
export class EmptySlotComponent {

    @Input() slot:CalendarSlot;

    public calendarTimeAsString(slot:CalendarDaySlot):string{
        return CalendarTime[slot.Time()];
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/calendar/emptySlot/emptySlot.ts